/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddPreseasonGameMessageDto } from '../models/AddPreseasonGameMessageDto';
import type { CancelPreseasonGameDto } from '../models/CancelPreseasonGameDto';
import type { ChangeDateTimeInApprovedPreseasonGameDto } from '../models/ChangeDateTimeInApprovedPreseasonGameDto';
import type { CreateManualPreseasonGameDto } from '../models/CreateManualPreseasonGameDto';
import type { CreatePreseasonGameDto } from '../models/CreatePreseasonGameDto';
import type { Pageable } from '../models/Pageable';
import type { PagePreseasonGameDetailsDto } from '../models/PagePreseasonGameDetailsDto';
import type { PreseasonGameDetailsDto } from '../models/PreseasonGameDetailsDto';
import type { PreseasonGameMessageDto } from '../models/PreseasonGameMessageDto';
import type { UpdateManualPreseasonGameDto } from '../models/UpdateManualPreseasonGameDto';
import type { UpdatePreseasonGameDateTimeDto } from '../models/UpdatePreseasonGameDateTimeDto';
import type { UpdatePreseasonGameDto } from '../models/UpdatePreseasonGameDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PreseasonGameControllerService {
    /**
     * @param id
     * @returns PreseasonGameDetailsDto OK
     * @throws ApiError
     */
    public static getPreseasonGameById(
        id: number,
    ): CancelablePromise<PreseasonGameDetailsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/preseason-games/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns PreseasonGameDetailsDto OK
     * @throws ApiError
     */
    public static updatePreseasonGame(
        id: number,
        requestBody: UpdatePreseasonGameDto,
    ): CancelablePromise<PreseasonGameDetailsDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/preseason-games/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns PreseasonGameDetailsDto OK
     * @throws ApiError
     */
    public static updateManualPreseasonGame(
        id: number,
        requestBody: UpdateManualPreseasonGameDto,
    ): CancelablePromise<PreseasonGameDetailsDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/preseason-games/{id}/manual',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param teamId
     * @returns PreseasonGameDetailsDto OK
     * @throws ApiError
     */
    public static rejectPreseasonGame(
        id: number,
        teamId: number,
        message?: string,
    ): CancelablePromise<PreseasonGameDetailsDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/preseason-games/{id}/reject',
            path: {
                'id': id,
            },
            query: {
                'teamId': teamId,
                'message': message,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns PreseasonGameDetailsDto OK
     * @throws ApiError
     */
    public static updatePreseasonGameDateTime(
        id: number,
        requestBody: UpdatePreseasonGameDateTimeDto,
    ): CancelablePromise<PreseasonGameDetailsDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/preseason-games/{id}/date-time',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param teamId
     * @param shouldBlockCalendar
     * @returns PreseasonGameDetailsDto OK
     * @throws ApiError
     */
    /**
     * @param id
     * @param teamId
     * @param requestBody
     * @returns PreseasonGameDetailsDto OK
     * @throws ApiError
     */
    public static updateScore(
        id: number,
        teamId: number,
        requestBody: { scoreMyTeam: number; scoreOpponentTeam: number },
    ): CancelablePromise<PreseasonGameDetailsDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/preseason-games/{id}/score',
            path: {
                'id': id,
            },
            query: {
                'teamId': teamId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    public static approvePreseasonGame(
        id: number,
        teamId: number,
        shouldBlockCalendar?: boolean,
        message?: string,
    ): CancelablePromise<PreseasonGameDetailsDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/preseason-games/{id}/approve',
            path: {
                'id': id,
            },
            query: {
                'teamId': teamId,
                'shouldBlockCalendar': shouldBlockCalendar,
                'message': message,
            },
        });
    }
    /**
     * @param requestBody
     * @returns PreseasonGameDetailsDto Created
     * @throws ApiError
     */
    public static createPreseasonGame(
        requestBody: CreatePreseasonGameDto,
    ): CancelablePromise<PreseasonGameDetailsDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/preseason-games',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns PreseasonGameDetailsDto Created
     * @throws ApiError
     */
    public static createManualPreseasonGame(
        requestBody: CreateManualPreseasonGameDto,
    ): CancelablePromise<PreseasonGameDetailsDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/preseason-games/manual',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns PreseasonGameDetailsDto OK
     * @throws ApiError
     */
    public static cancelPreseasonGame(
        id: number,
        requestBody: CancelPreseasonGameDto,
    ): CancelablePromise<PreseasonGameDetailsDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/preseason-games/{id}/cancel',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns PreseasonGameMessageDto Created
     * @throws ApiError
     */
    public static addMessage(
        requestBody: AddPreseasonGameMessageDto,
    ): CancelablePromise<PreseasonGameMessageDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/preseason-games/messages',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns PreseasonGameDetailsDto Created
     * @throws ApiError
     */
    public static changeDateTimeInApprovedPreseasonGame(
        requestBody: ChangeDateTimeInApprovedPreseasonGameDto,
    ): CancelablePromise<PreseasonGameDetailsDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/preseason-games/change-date-time',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns PreseasonGameDetailsDto OK
     * @throws ApiError
     */
    public static getPreseasonGamesByIds(
        requestBody: Array<number>,
    ): CancelablePromise<Array<PreseasonGameDetailsDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/preseason-games/by-ids',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param receiverTeamId
     * @param pageable
     * @returns PagePreseasonGameDetailsDto OK
     * @throws ApiError
     */
    public static getPendingPreseasonGamesByTeamReceiver(
        receiverTeamId: number,
        pageable: Pageable,
    ): CancelablePromise<PagePreseasonGameDetailsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/preseason-games/team/{receiverTeamId}/received/pending-preseason-games',
            path: {
                'receiverTeamId': receiverTeamId,
            },
            query: {
                'pageable': pageable,
            },
        });
    }
    /**
     * @param creatorTeamId
     * @param pageable
     * @returns PagePreseasonGameDetailsDto OK
     * @throws ApiError
     */
    public static getPreseasonGamesByTeamCreator(
        creatorTeamId: number,
        pageable: Pageable,
    ): CancelablePromise<PagePreseasonGameDetailsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/preseason-games/team/{creatorTeamId}/created/preseason-games',
            path: {
                'creatorTeamId': creatorTeamId,
            },
            query: {
                'pageable': pageable,
            },
        });
    }
    /**
     * @param creatorTeamId
     * @param pageable
     * @returns PagePreseasonGameDetailsDto OK
     * @throws ApiError
     */
    public static getPendingPreseasonGamesByTeamCreator(
        creatorTeamId: number,
        pageable: Pageable,
    ): CancelablePromise<PagePreseasonGameDetailsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/preseason-games/team/{creatorTeamId}/created/pending-preseason-games',
            path: {
                'creatorTeamId': creatorTeamId,
            },
            query: {
                'pageable': pageable,
            },
        });
    }
    /**
     * @param receiverSportsClubId
     * @param pageable
     * @returns PagePreseasonGameDetailsDto OK
     * @throws ApiError
     */
    public static getPendingPreseasonGamesBySportsClubReceiver(
        receiverSportsClubId: number,
        pageable: Pageable,
    ): CancelablePromise<PagePreseasonGameDetailsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/preseason-games/sports-club/{receiverSportsClubId}/received/pending-preseason-games',
            path: {
                'receiverSportsClubId': receiverSportsClubId,
            },
            query: {
                'pageable': pageable,
            },
        });
    }
    /**
     * @param creatorSportsClubId
     * @param pageable
     * @returns PagePreseasonGameDetailsDto OK
     * @throws ApiError
     */
    public static getPreseasonGamesBySportsClubCreator(
        creatorSportsClubId: number,
        pageable: Pageable,
    ): CancelablePromise<PagePreseasonGameDetailsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/preseason-games/sports-club/{creatorSportsClubId}/created/preseason-games',
            path: {
                'creatorSportsClubId': creatorSportsClubId,
            },
            query: {
                'pageable': pageable,
            },
        });
    }
    /**
     * @param creatorSportsClubId
     * @param pageable
     * @returns PagePreseasonGameDetailsDto OK
     * @throws ApiError
     */
    public static getPendingPreseasonGamesBySportsClubCreator(
        creatorSportsClubId: number,
        pageable: Pageable,
    ): CancelablePromise<PagePreseasonGameDetailsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/preseason-games/sports-club/{creatorSportsClubId}/created/pending-preseason-games',
            path: {
                'creatorSportsClubId': creatorSportsClubId,
            },
            query: {
                'pageable': pageable,
            },
        });
    }
    /**
     * @param id
     * @param acceptingTeamId
     * @returns PreseasonGameDetailsDto OK
     * @throws ApiError
     */
    public static approveLastMinutePreseasonGame(
        id: number,
        acceptingTeamId: number,
    ): CancelablePromise<PreseasonGameDetailsDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/preseason-games/{id}/approve-last-minute',
            path: {
                'id': id,
            },
            query: {
                'acceptingTeamId': acceptingTeamId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns PreseasonGameDetailsDto Created
     * @throws ApiError
     */
    public static getApprovedGamesSummary(
        teamId?: number,
        dateFrom?: string,
        dateTo?: string,
    ): CancelablePromise<Array<any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/preseason-games/summary',
            query: {
                'teamId': teamId,
                'dateFrom': dateFrom,
                'dateTo': dateTo,
            },
        });
    }

    public static searchLastMinutePreseasonGame(
        requestBody: {
            teamId: number;
            scheduleId: number;
            date?: string;
            startTime?: string;
            endTime?: string;
            message?: string;
        },
    ): CancelablePromise<PreseasonGameDetailsDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/preseason-games/search-last-minute',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
